//@import dependencies
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment';
//@end

//@import components
import IconComponent from 'app_components/commons/icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import AlertComponent from 'app_components/commons/alert';
import ModalAllianceFormModule from 'app_components/modules/admin/landings/modalAllianceForm/modalAllianceForm';
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
import LandingService from 'app_services/admin/landings/landingService'
// @end

// @INFO Import Styles
import './allianceFormModule.scss'
import { ILandingAlliance } from 'app_types/admin/landings/landingTypes';
import { FaFileUpload } from 'react-icons/fa';
import ModalAllianceBrochureFormModuleLayout from '../modalAllianceBrochureForm/modalAllianceBrochureForm';

// @ADD Component types
interface IAllianceFormModuleLayoutProps {
  title?: string
  addItem?: boolean
  editItem?: boolean
  deleteItem?: boolean
  source: string
  onHandleFormSubmited?: (data: {status: 'success' | 'error' | 'none', results?: any}) => void | null
  items: ILandingAlliance[] | undefined
}

const AllianceFormModuleLayout: React.FC<IAllianceFormModuleLayoutProps> = (props) => {

  const i18nUtil = new I18nUtil()
  const screenNotifications = new ScreenNotificationsUtil()
  const landingService = new LandingService()

  const {items, title, editItem, addItem, deleteItem, source, onHandleFormSubmited} = props;
  const [colors] = useColors()

  const [loadingForm, updateLoadingForm] = useState<'loading' | null>(null)
  const [modalFormStatus, setModalFormStatus] = useState<boolean>(false)
  const [modalFormUploadBrochure, setModalFormUploadBrochure] = useState<{alliance: ILandingAlliance | null, status: boolean}>({alliance: null, status: false})
  const [formEditData, setFormEditData] = useState<any>(null)

  const { t } = useTranslation()

  const handleOpenModalForm = () => {
    setModalFormStatus(true)
  }

  const handleCloseModalForm = async (data: any) => {
    setFormEditData(null)
    setModalFormStatus(false)
    if (data?.status === true && data?.data && onHandleFormSubmited) {
      onHandleFormSubmited({status: 'success'})
    }
  }

  const handleEditRegister = (register: ILandingAlliance) => {
    setFormEditData(register)
    setModalFormStatus(true)
  }

  const handleRemoveRegister = async (unique: string | undefined) => {
    if (unique) {
      const confirm = screenNotifications.fire({
        message: `${i18nUtil.getTranslate('modules.alliance_form.delete_alert.message')}`,
      },
      {
        type: 'warning',
        title: `${i18nUtil.getTranslate('modules.alliance_form.delete_alert.title')}`,
        confirmButtonText: `${i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
        cancelButtonText: `${i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,
        showCancelButton: true,
      })

      if (confirm) {
        confirm.then(async (result) => {
          if (result.value) {
            updateLoadingForm('loading')

            const remove = await landingService.removeAlliance(source, unique)

            updateLoadingForm(null)

            if (remove) {
              screenNotifications.fireToast({
                message: `${i18nUtil.getTranslate('components.screen_notifications.delete')}`,
              },
              {
                position: 'top',
              })

              if (onHandleFormSubmited) {
                onHandleFormSubmited({status: 'success'})
              }
            }
          }
        })
      }
    }
  }

  const handleUploadBrochure = (alliance: ILandingAlliance) => {
    setModalFormUploadBrochure({alliance, status: true})
  }
  const handleCloseModalUploadBrochureForm = async (data: any) => {
    setModalFormUploadBrochure({alliance: null, status: false})
    if (data?.status === true && data?.data && onHandleFormSubmited) {
      onHandleFormSubmited({status: 'success'})
    }
  }

  return(
    <div className='alliance_form-module'>
      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{title || t('modules.alliance_form.title')}</h3>
      </div>

      <div className="row">
        {addItem && (
          <div className="col-12 text-right mb-3">
            <button className="btn btn-primary" onClick={handleOpenModalForm} type="button" disabled={loadingForm === 'loading'}>
              <IconComponent fontawesome={{icon: 'fa fa-plus'}} />&nbsp;&nbsp;
              {t("modules.alliance_form.add")}
            </button>
          </div>
        )}
      {items && items?.length > 0 ? (
        <>
          {items.map((alliance) => (
            <div className="col-12">
              <div className="alliance-item">
                <div className="alliance-content">
                  <div className='alliance-content-main'>
                    {alliance.logoFile ? (
                      <a href={alliance.logoFile} target='_blank' rel="noreferrer">
                        <div style={{backgroundImage: `url(${alliance.logoFile})`}}></div>
                      </a>
                    ): null}
                    <span>{alliance.name}</span>
                  </div>
                  <div className="alliance-content-element">
                    <b>{t('labels.modal_alliance_form.status')}</b>: {alliance?.status ? 'Activo' : 'Inactivo'}
                  </div>
                  <div className="alliance-content-element">
                    <b>{t('labels.modal_alliance_form.typeAgreement')}</b>: {landingService.getTypeAgreementLabel(alliance?.typeAgreement)}
                  </div>
                  {alliance?.country ? (
                    <div className="alliance-content-element">
                      <b>{t('labels.modal_alliance_form.country')}</b>: {alliance?.country}
                    </div>
                  ): null}
                  {alliance?.regional ? (
                    <div className="alliance-content-element">
                      <b>{t('labels.modal_alliance_form.regional')}</b>: {alliance?.regional}
                    </div>
                  ): null}
                  {alliance?.creationYear ? (
                    <div className="alliance-content-element">
                      <b>{t('labels.modal_alliance_form.creationYear')}</b>: {moment.utc(alliance?.creationYear).format('YYYY-MM-DD')}
                    </div>
                  ): null}
                  {alliance?.programs && alliance.programs.length > 0 ? (
                    <div className="alliance-content-element">
                      <b>{t('labels.modal_alliance_form.programs')}</b>:
                      <ul>
                        {alliance?.programs.map((program) => (
                          <li>{program}</li>
                        ))}
                      </ul>
                    </div>
                  ): null}
                  {alliance?.webSite ? (
                    <div className="alliance-content-element">
                      <b>{t('labels.modal_alliance_form.webSite')}</b>: <a href={alliance?.webSite} target="__blank" rel="noopener noreferrer">{alliance?.webSite}</a>
                    </div>
                  ): null}
                  {alliance?.contact ? (
                    <div className="alliance-content-element">
                      <b>{t('labels.modal_alliance_form.contact')}</b>: {alliance?.contact}
                    </div>
                  ): null}
                </div>
                <div className="alliance-actions">
                  {addItem || editItem ? (
                    <OverlayTrigger
                      trigger={['hover', 'focus']}
                      placement={'top'}
                      overlay={
                        <Tooltip id='toolip-circle'>
                          {t("modules.alliance_form.upload_brochure")}
                        </Tooltip>
                      }>
                        <button className="session-action" onClick={() => handleUploadBrochure(alliance)} disabled={loadingForm === 'loading'}>
                          <FaFileUpload color={colors.primary}/>
                        </button>
                    </OverlayTrigger>
                  ): null}
                  {editItem ? (
                    <OverlayTrigger
                      trigger={['hover', 'focus']}
                      placement={'top'}
                      overlay={
                        <Tooltip id='toolip-circle'>
                          {t("modules.alliance_form.edit")}
                        </Tooltip>
                      }>
                        <button className="session-action" onClick={() => handleEditRegister(alliance)} disabled={loadingForm === 'loading'}>
                          <IconComponent fontawesome={{icon: 'fas fa-edit'}} color={colors.primary} />
                        </button>
                    </OverlayTrigger>
                    ): null}
                    {deleteItem && alliance?.unique ? (
                      <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement={'top'}
                        overlay={
                          <Tooltip id='toolip-circle'>
                            {t("modules.alliance_form.delete")}
                          </Tooltip>
                        }>
                          <button className="session-action" onClick={() => handleRemoveRegister(alliance.unique)} disabled={loadingForm === 'loading'}>
                            <IconComponent fontawesome={{icon: 'fas fa-trash-alt'}} color={colors.primary} />&nbsp;&nbsp;
                          </button>
                      </OverlayTrigger>
                    ): null}
                </div>

              </div>
            </div>
          ))}
        </>
        ) : (
          <div className="col-12">
            <AlertComponent
              type='warning'
              title={t('modules.alliance_form.no_data')}
            />
          </div>
        )}

      </div>
      {modalFormStatus && (
        <ModalAllianceFormModule
          source={source}
          open={modalFormStatus}
          handleClose={handleCloseModalForm}
          editData={formEditData}
          fields={['country', 'contact', 'creationYear', 'programs', 'regional', 'regional', 'webSite', 'sectional']}
        />
      )}
      {modalFormUploadBrochure?.status && modalFormUploadBrochure?.alliance?.unique ? (
        <ModalAllianceBrochureFormModuleLayout
          source={source}
          allianceUnique={modalFormUploadBrochure.alliance.unique}
          open={modalFormUploadBrochure?.status}
          handleClose={handleCloseModalUploadBrochureForm}
          editData={modalFormUploadBrochure?.alliance?.brochures}
        />
      ): null}
    </div>
  )
}

export default AllianceFormModuleLayout
